import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import ModalWrapper from 'components/Modals/ModalWrapper';
import LinkWhsOperationMonitor from 'components/LinkWhsOperationMonitor';

const LinkWhsAccountModal = ({
  isShown,
  accountWhsLinkStatus,
  accountId,
  reloadOnComplete,
  accountWhsLinkMonitorFailed
}) => (<ModalWrapper
  isOpen={ isShown }
  showFooter={ false }
  showConfirm={ false }
  showClose={ false }
  showCancel={ false }
  headerClose={ false }
  title="Linking IMY Tree Structure"
>
  <LinkWhsOperationMonitor
    accountId={ accountId }
    accountWhsLinkStatus={ accountWhsLinkStatus }
    reloadOnComplete={ reloadOnComplete }
    accountWhsLinkMonitorFailed={ accountWhsLinkMonitorFailed }
  />
</ModalWrapper>);

LinkWhsAccountModal.propTypes = {
  isShown: PropTypes.bool,
  accountId: PropTypes.number,
  accountWhsLinkStatus: PropTypes.shape(),
  reloadOnComplete: PropTypes.bool,
  accountWhsLinkMonitorFailed: PropTypes.bool
};

LinkWhsAccountModal.defaultProps = {
  isShown: false,
  accountId: null,
  accountWhsLinkStatus: null,
  reloadOnComplete: false,
  accountWhsLinkMonitorFailed: false
};

function mapStateToProps(state) {
  const {
    account: {
      accountWhsLinkStatus,
      accountWhsLinkMonitorFailed
    }
  } = state;

  return {
    accountWhsLinkStatus,
    accountWhsLinkMonitorFailed
  };
}

export default connect(mapStateToProps)(LinkWhsAccountModal);
